import React from "react";
import { Switch } from "@/components/ui/switch";
import { useCatMode, writeCatMode } from "@/lib/catMode";

export default function CatModeToggle({ compact = false, floating = false }) {
  const catMode = useCatMode();
  const classes = floating
    ? "fixed right-4 top-4 z-50 rounded-md border border-border bg-black/80 px-3 py-2 text-[11px] shadow-xl backdrop-blur-xl"
    : compact
      ? "text-[11px]"
      : "mt-4 justify-between rounded-md border border-border bg-white/[0.02] px-3 py-2 text-xs";
  return (
    <label className={`flex items-center gap-2 ${classes}`}>
      <span className="font-mono uppercase tracking-label text-muted-foreground">Cat Mode</span>
      <Switch checked={catMode} onCheckedChange={writeCatMode} aria-label="Toggle cat mode" />
    </label>
  );
}
